/* eslint-disable react/no-unescaped-entities */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  LinearProgress
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import React, { useContext, useEffect, useState } from 'react'

import ToastMessages from '../../components/ToastMessages'
import {
  addOrEditCommunicationMaterial,
  getCommunicationMaterialsList
} from '../../services/ClubeApi'
import { getLoggedUser, isAuthenticated } from '../../services/auth'

import Context from '../../context'
import ImageUploadToS3 from '../../services/ImageUpload'
import history from '../../services/history'

function CommunicationMaterials() {
  const { setUser, setAboutCurrentPage, setOpenToast } = useContext(Context)
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [createModalData, setCreateModalData] = useState(null)
  const [deleteModalData, setDeleteModalData] = useState(null)
  const classes = useStyles()
  const acceptTypes = [
    'image/jpeg',
    'image/png',
    'image/gif',
    'application/pdf',
    'video/avi',
    'video/mp4',
    'application/zip'
  ]

  useEffect(() => {
    if (!isAuthenticated()) return history.replace('/')

    setUser(getLoggedUser)
    getData()
    setAboutCurrentPage({
      title: 'Comunicações',
      buttons: [{ title: 'Nova comunicação', onClick: showAddModal }]
    })
  }, [])

  function changeCreateModalData(newData) {
    setCreateModalData(oldData => ({
      ...oldData,
      ...newData
    }))
  }

  async function getData() {
    try {
      setLoading(true)
      let data = await getCommunicationMaterialsList()
      setData(data)
    } catch {
      //
    } finally {
      setLoading(false)
    }
  }

  function showCreateModal(item) {
    return function () {
      setCreateModalData({
        ...item
      })
    }
  }
  const showAddModal = showCreateModal({
    title: '',
    description: '',
    url: null,
    version: 0
  })

  function hideCreateModal() {
    setCreateModalData(null)
  }

  function checkErrors(data) {
    if (!data.title.trim()) return 'Defina um título'
    if (!data.description.trim()) return 'Defina uma descrição'
    if (!data.url) return 'Escolha um arquivo'
    return null
  }

  async function createItem(item) {
    let error = checkErrors(item)
    if (error) {
      setOpenToast({
        open: true,
        message: error,
        type: 'error'
      })
      return
    }

    try {
      hideCreateModal()
      setData(null)
      setLoading(true)

      let url =
        item.url instanceof File
          ? process.env.REACT_APP_IMAGES_URL +
            (await ImageUploadToS3(item.url, 'files/communications-materials/'))
          : item.url

      await addOrEditCommunicationMaterial({
        ...item,
        url,
        version: item.version + 1
      })
      await getData()
    } catch {
      //
    }
  }

  function showDeleteModal(item) {
    return function () {
      setDeleteModalData(item)
    }
  }

  function hideDeleteModal() {
    setDeleteModalData(null)
  }

  async function deleteItem(item) {
    try {
      setDeleteModalData(null)
      setData(null)
      setLoading(true)
      await addOrEditCommunicationMaterial({
        ...item,
        situation: 2
      })
      await getData()
    } catch {
      //
    }
  }

  function openFile(e, url) {
    e.preventDefault()
    window.open(typeof url === 'string' ? url : URL.createObjectURL(url), '_blank')
  }

  return (
    <>
      <div className={classes.outerContainer}>
        <table className={classes.table}>
          <colgroup>
            <col className={classes.fitContent} />
            <col className={classes.fitContent} />
            <col />
          </colgroup>
          <thead>
            <tr>
              <td>Título</td>
              <td>Tipo do arquivo</td>
              <td>Descrição</td>
            </tr>
          </thead>
          <tbody>
            {!loading &&
              data?.map(item => (
                <tr key={item.id}>
                  <td className={classes.titleContainer}>
                    <div>{item.title}</div>
                    <div>
                      <a onClick={showCreateModal(item)}>Editar</a>
                      {' | '}
                      <a onClick={showDeleteModal(item)}>Excluir</a>
                    </div>
                  </td>
                  <td>
                    {{
                      pdf: 'PDF',
                      mp4: 'Vídeo',
                      avi: 'Vídeo',
                      jpeg: 'Imagem',
                      jpg: 'Imagem',
                      png: 'Imagem',
                      gif: 'Imagem'
                    }[item.url?.replace(/.+\.(.*?)$/, '$1')] || '---'}
                  </td>
                  <td>{item.description}</td>
                </tr>
              ))}
            {!loading && data?.length === 0 && (
              <tr>
                <td colSpan="3">Nenhum resultado</td>
              </tr>
            )}
          </tbody>
        </table>
        {loading ? <LinearProgress style={{ marginTop: 30 }} /> : null}
      </div>

      <Dialog
        open={!!createModalData}
        onClose={hideCreateModal}
        transitionDuration={{ enter: 250, exit: 0 }}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>{createModalData?.id ? 'Editar' : 'Adicionar'} comunicação</DialogTitle>
        <DialogContent className={classes.main}>
          <div className={clsx(classes.inputGroup, classes.firstTwoRows)}>
            <span>Arquivo</span>
            <label className={classes.file}>
              <input
                type="file"
                onChange={e =>
                  changeCreateModalData({
                    url: e.target.files[0]
                  })
                }
                accept={acceptTypes.join(',')}
              />
              Escolher arquivo
            </label>
            {createModalData?.url && (
              <a onClick={e => openFile(e, createModalData.url)}>Abrir em nova guia</a>
            )}
          </div>
          <div className={clsx(classes.inputGroup, classes.secondColumn)}>
            <span>Título</span>
            <input
              value={createModalData?.title}
              onChange={e =>
                changeCreateModalData({
                  title: e.target.value
                })
              }
            />
          </div>
          {!!createModalData && (
            <div className={clsx(classes.inputGroup, classes.secondColumn)}>
              <span>Descrição</span>
              <textarea
                value={createModalData?.description}
                onChange={e =>
                  changeCreateModalData({
                    description: e.target.value
                  })
                }
              />
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button color="primary" onClick={() => createItem(createModalData)}>
            Salvar
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={!!deleteModalData}
        onClose={hideDeleteModal}
        transitionDuration={{ enter: 250, exit: 0 }}
      >
        <DialogTitle>Excluir comunicação</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Deseja realmente excluir a comunicação "{deleteModalData?.title}"?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color="primary" onClick={hideDeleteModal}>
            Não
          </Button>
          <Button color="primary" onClick={() => deleteItem(deleteModalData)}>
            Sim
          </Button>
        </DialogActions>
      </Dialog>

      <ToastMessages />
    </>
  )
}

const useStyles = makeStyles({
  outerContainer: {
    display: 'flex',
    flexDirection: 'column',
    fontFamily: 'Montserrat',
    fontWeight: '500'
  },
  table: {
    marginTop: '20px',
    whiteSpace: 'nowrap',
    border: '2px solid #30287b',
    '& td': {
      border: '2px solid #30287b'
    },
    '& thead': {
      background: '#30287b'
    },
    '& thead td': {
      fontSize: '12px',
      padding: '17px 25px',
      fontWeight: '700',
      color: '#ffffff',
      lineHeight: '13px',
      textTransform: 'uppercase'
    },
    '& tbody td': {
      fontSize: '14px',
      padding: '17px 25px',
      color: '#30287b'
    }
  },
  fitContent: {
    width: 'fit-content'
  },
  titleContainer: {
    '& div:first-child': {
      marginBottom: '17px',
      fontWeight: '700'
    },
    '& div:last-child': {
      fontSize: '12px',
      '& a': {
        cursor: 'pointer'
      },
      '& a:not(:last-child)': {
        color: '#30287b'
      },
      '& a:last-child': {
        color: '#d73f32'
      }
    }
  },
  file: {
    alignSelf: 'center',
    objectFit: 'cover',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: 44,
    margin: '10px 0 0',
    background: '#eee',
    cursor: 'pointer',
    '& + a': {
      cursor: 'pointer'
    }
  },
  inputGroup: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    '& > span': {
      fontSize: '16px',
      fontWeight: 700,
      color: '#30287b'
    },
    '& > input, & > div, & textarea': {
      marginTop: '10px',
      background: '#fff',
      border: '2px solid #30287b !important'
    },
    '& input, & textarea': {
      padding: '11px 13px',
      fontSize: '14px',
      color: '#30287b',
      border: 'none'
    },
    '& > div': {
      display: 'flex',
      flexDirection: 'row'
    },
    '& > div input': {
      flexGrow: 1,
      height: '100%'
    },
    '& > input, & > div': {
      height: 44
    },
    '& textarea': {
      minHeight: 132,
      resize: 'none'
    },
    '& input[type="file"]': {
      position: 'absolute',
      opacity: 0,
      transform: 'scale(0)'
    }
  },
  main: {
    flexGrow: 1,
    display: 'grid',
    gridTemplateColumns: '160px auto',
    gap: '30px 60px'
  },
  firstTwoRows: {
    gridRow: '1 / 3'
  },
  twoColumns: {
    gridColumn: '1 / 3'
  },
  secondColumn: {
    gridColumn: '2 / 3'
  }
})

export default CommunicationMaterials
